import { lazy } from "react";
//import Home from "../modules/Home";
import Login from "../modules/Auth/Login";
import PasswordRecovery from "../modules/Auth/PasswordRecovery";
import UserPasswordUpdate from "../modules/Auth/UserPasswordUpdate";
import {
  BusinessType,
  BusinessUnitInterface,
  UserInterface,
} from "../interfaces";


// Every screen behind authentication is code-split. They used to be static
// imports, so the bundle the login page downloads carried all 23 of them.
// Login, PasswordRecovery and UserPasswordUpdate stay eager: they are the
// unauthenticated entry points and must paint without a second round-trip.
const AuditLogPage = lazy(() => import("../modules/Audit/AuditLogPage"));
const CashDesk = lazy(() => import("../modules/CashDesk"));
const Clients = lazy(() => import("../modules/Clients"));
const CouponBadgePreview = lazy(() => import("../modules/Dev/CouponBadgePreview"));
const Dashboard = lazy(() => import("../modules/Dashboard"));
const Dispatch = lazy(() => import("../modules/Dispatch"));
const DispatchCreate = lazy(() => import("../modules/DispatchCreate"));
const Documents = lazy(() => import("../modules/Documents"));
const ExchangeRateHistorical = lazy(
  () => import("../modules/ExchangeRateHistorical/ExchangeRateHistorical")
);
const InternalMail = lazy(() => import("../modules/InternalMail/InternalMail"));
const Inventory = lazy(() => import("../modules/Inventory"));
const InventoryCreate = lazy(() => import("../modules/InventoryCreate"));
const LabelSettings = lazy(() => import("../modules/LabelSettings"));
const PDocuments = lazy(() => import("../modules/PDocuments"));
const PendingDispatch = lazy(() => import("../modules/PendingDispatch/PendingDispatch"));
const PendingPayments = lazy(() => import("../modules/PendingPayments"));
const Pickup = lazy(() => import("../modules/Pickup/Pickup"));
const PriceCalculator = lazy(() => import("../modules/PriceCalculator"));
const Profile = lazy(() => import("../modules/Profile"));
const Receipt = lazy(() => import("../modules/Receipt"));
const ReceiptCreate = lazy(() => import("../modules/ReceiptCreate"));
const ShipmentCreate = lazy(() => import("../modules/Shipments/ShipmentCreate"));
const Shipments = lazy(() => import("../modules/Shipments"));
const TestLab = lazy(() => import("../modules/TestLab"));

export interface AppRoute {
  index?: boolean;
  path?: string;
  element: React.ReactNode;
  /**
   * If the route needs authentication
   */
  auth?: boolean;
  exact?: boolean;
  rolesRequired?: string[];
  filter?: (user?: UserInterface, bu?: BusinessUnitInterface) => boolean;
}

const filterConsultUser = (
  user?: UserInterface,
  bu?: BusinessUnitInterface,
) => {
  return (
    [
      "Taquillero",
      "Supervisor",
      "Administrador",
      "Superadministrador",
    ].includes(user?.roleName ?? "") ||
    bu?.type === BusinessType.VIRTUAL_STORE_FOR_INTERNAL_USE
  );
};

const AppRoutes: AppRoute[] = [
  { path: "/login", element: <Login />, auth: false },
  {
    path: "/user-password-reset/:userLoginEmailToken?/:userToken?",
    element: <UserPasswordUpdate />,
    auth: false,
  },
  {
    path: "/user-password-update",
    element: <UserPasswordUpdate />,
    auth: false,
    exact: true,
  },
  { path: "/password-recovery", element: <PasswordRecovery />, auth: false },
  { index: true, path: "/*", element: <Login />, auth: false },

  { path: "/dashboard", element: <Dashboard />, auth: true },
  { path: "/shipment-create", element: <ShipmentCreate />, auth: true },
  { path: "/shipments/:shipmentNumber?", element: <Shipments />, auth: true },
  { path: "/shipments", element: <Shipments />, auth: true },
  { path: "/documents/:documentId?", element: <Documents />, auth: true },
  { path: "/documents", element: <Documents />, auth: true },
  { path: "/pending-payments", element: <PendingPayments />, auth: true },
  { path: "/estimation", element: <PriceCalculator />, auth: true },
  { path: "/pick-up", element: <Pickup />, auth: true },
  { path: "/cash-desk", element: <CashDesk />, auth: true },
  { path: "/profile", element: <Profile />, auth: true },
  { path: "/label-settings", element: <LabelSettings />, auth: true },
  {
    path: "/pdocuments",
    element: <PDocuments />,
    auth: true,
    rolesRequired: ["Administrador", "Superadministrador"],
  },
  {
    path: "/user-password-update",
    element: <UserPasswordUpdate />,
    auth: true,
    exact: true,
  },
  { index: true, path: "/*", element: <Dashboard />, auth: true },
  { path: "/test", element: <TestLab />, auth: true },
  { path: "/clients", element: <Clients />, auth: true },
  {
    path: "/dispatch",
    element: <Dispatch />,
    auth: true,
    filter: filterConsultUser,
  },
  {
    path: "/dispatch/create",
    element: <DispatchCreate />,
    auth: true,
    filter: filterConsultUser,
  },
  {
    path: "/inventory",
    element: <Inventory />,
    auth: true,
    filter: filterConsultUser,
  },
  {
    path: "/inventory/create",
    element: <InventoryCreate />,
    auth: true,
    filter: filterConsultUser,
  },
  {
    path: "/receipt",
    element: <Receipt />,
    auth: true,
    filter: filterConsultUser,
  },
  {
    path: "/receipt/create",
    element: <ReceiptCreate />,
    auth: true,
    filter: filterConsultUser,
  },
  {
    path: "/internal-mail",
    element: <InternalMail />,
    auth: true,
    filter: filterConsultUser,
  },
  {
    path: "/audit-log",
    element: <AuditLogPage />,
    auth: true,
    rolesRequired: ["Consulta Innovus", "Administrador", "Superadministrador"],
  },
  {
    path: "/pending-dispatch",
    element: <PendingDispatch />,
    auth: true,
    filter: filterConsultUser,
  },
  {
    path: "/exchange-rate-historical",
    element: <ExchangeRateHistorical />,
    auth: true,
    //filter: filterConsultUser,
  },
  // Temporary dev preview for the "Vuelve Tu Envío Premiado" promo badge +
  // redeemed animation. Remove after Marketing sign-off.
  {
    path: "/dev/coupon-badge-preview",
    element: <CouponBadgePreview />,
    auth: true,
  },
];

export default AppRoutes;
